import {
  DocumentKkb,
  DocumentToSign,
  DocumentType,
} from "../../store/slice/requestAppSlise/requestAppSlise";

export const getDocumentTitleDown = (documentDto: DocumentToSign) => {
  if (documentDto.type_doc.type === "ANKETA") {
    return "Анкета.pdf";
  }
  if (documentDto.type_doc.name) {
    return documentDto.type_doc.name;
  }
  return "Документ не загружен";
};
export const getDocumentTitleDownOther = (
  documentDto: DocumentType<DocumentKkb>,
) => {
  if (documentDto.type === "ANKETA") {
    return "Анкета.pdf";
  }
  if (documentDto.name) {
    return documentDto.name;
  }
  return "Документ не загружен";
};
